import { ChevronLeftIcon } from "@chakra-ui/icons";
import { Box, Button, Flex, Heading, IconButton, Text } from "@chakra-ui/react";

import { JobCircularScore, JobDescription } from "components";
import { HeartOulinedIcon } from "components/base/atoms/HJSIcons";
import JobAppliedModal from "components/base/molecules/JobAppliedModal";
import { aiScoresGroup, preferenceScoreGroup } from "config/Consts";
import { useGetUserProfileQuery } from "queries";
import { useSaveJobsQuery, useUnsaveJobQuery } from "queries/Jobs";
import { memo, useEffect, useState } from "react";
import { updateJobSavedStatus } from "utils/jobs";

interface IJObDetails {
  isMobile: boolean;

  backBtn: (arg?: any) => void;
  scores?: any[];
  jobData: any;
  setAllJobs?: (arg?: any) => void;
  index?: number;
  backdropHandler: any;
}

const JobDetails = ({
  isMobile,
  backBtn,

  scores,
  jobData,
  setAllJobs,
  index,
  backdropHandler,
}: IJObDetails): JSX.Element => {
  const [openModal, setOpenModal] = useState<boolean>(false);
  const [applied, setApplied] = useState(false);
  const [isNotInterested, setInterested] = useState<boolean>(false);

  const { data: userData } = useGetUserProfileQuery();

  const { mutate: saveJobQuery, isLoading: saveLoading } = useSaveJobsQuery();
  const { mutate: unSaveJobQuery, isLoading: unsaveLoading } =
    useUnsaveJobQuery();

  const isJobSaved = jobData?.isSaved as boolean;

  const handleSaveUnsaveJob = (): void => {
    if (!isJobSaved) {
      backdropHandler?.(false);
      saveJobQuery(
        { jobId: jobData?._id },
        {
          onSuccess: () => {
            updateJobSavedStatus({ setAllJobs, isSaved: true, index });
          },
        }
      );
    } else if (isJobSaved) {
      unSaveJobQuery(
        { jobId: jobData?._id },
        {
          onSuccess: () => {
            updateJobSavedStatus({ setAllJobs, isSaved: false, index });
          },
        }
      );
    }
  };

  const handleApplied = (status: boolean): void => {
    setApplied(status);
  };
  useEffect(() => {
    setApplied(jobData?.isApplied);
    setInterested(jobData?.notInterested);
  }, [jobData?.isApplied, jobData?.notInterested]);

  return (
    <>
      {openModal && (
        <JobAppliedModal
          openModal={openModal}
          setOpenModal={setOpenModal}
          id={jobData?._id}
          jobName={jobData?.title}
          company={jobData?.CompanyName}
          handleApplied={handleApplied}
          index={index}
          setAllJobs={setAllJobs}
          setInterested={setInterested}
          isNotInterested={isNotInterested}
        />
      )}

      <Box
        // minH="90vh"
        overflowX="hidden"
        overflowY="auto"
        maxH="100%"
        // height="calc(100% - 70px)"
        className="flex flex-col gap-4"
      >
        <Box className="flex justify-between items-center ">
          <Heading
            as="h6"
            className="flex items-center"
            fontSize={[14, 18, 24]}
            onClick={backBtn}
            _hover={{
              cursor: isMobile ? "pointer" : "initial",
            }}
          >
            {isMobile && <ChevronLeftIcon />}
            {jobData?.title}
          </Heading>

          <IconButton
            variant="link"
            colorScheme="gray"
            aria-label="Remove Job"
            isLoading={saveLoading || unsaveLoading}
            icon={
              <HeartOulinedIcon
                fill={isJobSaved ? "#DE2F2F" : "transparent"}
                stroke="black"
                strokeWidth={1}
                width={{ base: 6, md: 6, lg: 7 }}
                height={{ base: 4, md: 4, lg: 5 }}
              />
            }
            onClick={handleSaveUnsaveJob}
          />
        </Box>

        <Flex>
          {aiScoresGroup.includes(userData?.group) && (
            <Flex className="items-center gap-4 flex-1">
              <JobCircularScore
                value={scores?.[1]}
                color="hjsAiScore"
                isAiScore
              />
              <Text fontWeight={600} className="font-size-xs">
                AI Score
              </Text>
            </Flex>
          )}
          {preferenceScoreGroup.includes(userData?.group) && (
            <Flex className="items-center gap-4 flex-1">
              <JobCircularScore
                color="hjsPreferenceScore"
                value={scores?.[0]}
              />
              <Text className="font-size-xs" fontWeight={600}>
                Preference Score
              </Text>
            </Flex>
          )}
        </Flex>

        <JobDescription jobData={jobData} />
      </Box>

      <Button
        background="primaryGold"
        color="white"
        _hover={{
          background: "#aa7203 !important",
        }}
        onClick={() => {
          window.open(jobData?.guid, "_blank");
          (!applied || isNotInterested) && setOpenModal(true);
        }}
        position="absolute"
        bottom={2}
        right={5}
        // isDisabled={applied}
        opacity={applied || isNotInterested ? 0.65 : 1}
      >
        {applied && !isNotInterested ? "Applied" : "Apply now!"}
        {/* Apply now */}
      </Button>
    </>
  );
};

export default memo(JobDetails);
